<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 sales-invoice-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("SALES_INVOICES.EDIT_SALES_INVOICE") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <sales-invoice-form
              :loading="loading"
              :salesInvoiceData="salesInvoice"
              :formErrors="formErrors"
              @salesInvoiceSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import SalesInvoiceForm from "./partials/SalesInvoiceForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSalesInvoice from "./defaultSalesInvoice";

export default {
  layout: "DashboardLayout",

  components: { SalesInvoiceForm },

  mixins: [alertLeave],

  data() {
    return {
      salesInvoice: cloneDeep(defaultSalesInvoice),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("salesInvoices/get", id);
        this.salesInvoice = this.$store.getters["salesInvoices/salesInvoice"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List SalesInvoices" });
    },

    viewSalesInvoice() {
      this.alertLeave = false;
      this.$router.push({
        name: "View SalesInvoice",
        params: { id: this.salesInvoice.id },
      });
    },

    async handleSubmit(salesInvoice) {
      this.loading = true;
      const salesInvoiceData = cloneDeep(salesInvoice);
      if (salesInvoiceData.sourceWarehouse) {
        if (!salesInvoiceData.sourceWarehouse.id) {
          delete salesInvoiceData.sourceWarehouse;
        }
      }
      try {
        await this.$store.dispatch("salesInvoices/update", salesInvoiceData);
        this.$notify({
          type: "success",
          message: this.$t("SALES_INVOICES.SALES_INVOICE_UPDATED"),
        });
        this.viewSalesInvoice();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
